import { FC } from 'react';
import { Box } from '@wix/design-system';
import ReplyReview from '../ReplyReview';
import WriteReplyReview from '../WriteReplyReview/WriteReplyReview';
import { ReplyProps, ReviewProps } from '../types';

export const reviewReplyDialogueDatahooks = {
  container: 'review-reply-dialogue-container',
};

export type IReviewReplyDialogueProps = ReplyProps &
  Pick<
    ReviewProps,
    'review' | 'isMyProfile' | 'isMobileView' | 'handleBiGenericClick'
  > & { replyAuthorTitle: string };

const ReviewReplyDialogue: FC<IReviewReplyDialogueProps> = ({
  review,
  replyAuthorTitle,
  isMyProfile,
  writeReplyToReview,
  hasActionMenu,
  deleteReply,
  isMobileView,
  isUsingReplyModal,
  handleBiGenericClick,
  replyStyleProps,
}) => {
  const reply = review?.reply;

  if (isMyProfile) {
    return (
      <Box
        display="block"
        dataHook={reviewReplyDialogueDatahooks.container}
        width={
          replyStyleProps?.writeReplyBoxVariant === 'full'
            ? '100%'
            : 'fit-content'
        }
        margin={replyStyleProps?.margin || 'SP4 0 0 0'}
      >
        <WriteReplyReview
          review={review}
          writeReplyToReview={writeReplyToReview}
          isMobileView={isMobileView}
          isUsingMobileModal={isUsingReplyModal}
          handleBiGenericClick={handleBiGenericClick}
          hasActionMenu={hasActionMenu}
          deleteReply={deleteReply}
          replyStyleProps={replyStyleProps}
        />
      </Box>
    );
  }

  return reply ? (
    <Box
      display="block"
      dataHook={reviewReplyDialogueDatahooks.container}
      margin={replyStyleProps?.margin || 'SP4 0 0 0'}
    >
      <ReplyReview reply={reply} replyTitleKey={replyAuthorTitle} />
    </Box>
  ) : null;
};

export default ReviewReplyDialogue;
